import React from 'react';
import RootSvg, { RootSvgProps } from '@/components/icons/RootSvg';

export default function SvgMoney(props: RootSvgProps) {
  return (
    <RootSvg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_5775_5602)">
        <g clipPath="url(#clip1_5775_5602)">
          <path
            d="M5.27083 15C4.09028 15 3.08333 14.5833 2.25 13.75C1.41667 12.9167 1 11.9097 1 10.7292C1 10.2431 1.07986 9.77083 1.23958 9.3125C1.39931 8.85417 1.625 8.4375 1.91667 8.0625L4.625 4.625L3.125 1H12.875L11.3542 4.625L14.0833 8.0625C14.375 8.4375 14.6007 8.85417 14.7604 9.3125C14.9201 9.77083 15 10.2431 15 10.7292C15 11.9097 14.5833 12.9167 13.75 13.75C12.9167 14.5833 11.9097 15 10.7292 15H5.27083ZM8 11.25C7.51389 11.25 7.10069 11.0799 6.76042 10.7396C6.42014 10.3993 6.25 9.98611 6.25 9.5C6.25 9.01389 6.42014 8.60069 6.76042 8.26042C7.10069 7.92014 7.51389 7.75 8 7.75C8.48611 7.75 8.89931 7.92014 9.23958 8.26042C9.57986 8.60069 9.75 9.01389 9.75 9.5C9.75 9.98611 9.57986 10.3993 9.23958 10.7396C8.89931 11.0799 8.48611 11.25 8 11.25ZM6 4H10L10.625 2.5H5.375L6 4ZM5.27083 13.5H10.7292C11.4931 13.5 12.1458 13.2292 12.6875 12.6875C13.2292 12.1458 13.5 11.4931 13.5 10.7292C13.5 10.4097 13.4479 10.1042 13.3438 9.8125C13.2396 9.52083 13.0903 9.25 12.8958 9L10.1458 5.5H5.85417L3.10417 9C2.90972 9.25 2.76042 9.52083 2.65625 9.8125C2.55208 10.1042 2.5 10.4097 2.5 10.7292C2.5 11.4931 2.77083 12.1458 3.3125 12.6875C3.85417 13.2292 4.50694 13.5 5.27083 13.5Z"
            fill="#666666"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_5775_5602">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="matrix(0 -1 1 0 0 16)"
          />
        </clipPath>
        <clipPath id="clip1_5775_5602">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </RootSvg>
  );
}
